import React, { useRef, useState } from "react";
import classNames from "classnames";

import "./Accordion.scss";

import { ReactComponent as ArrowGrayIcon } from "static/icons/arrow-gray.svg";
import { ReactComponent as Trash } from "static/icons/trash.svg";

const Accordion = ({ headerComponent, headerProps, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const renderAccordionHeader = ({ title, icon, clearHandler }) => {
    return (
      <>
        <div className="accordion__header__right-content">
          <div className="icon">{icon}</div>
          <div>{title}</div>
        </div>

        <div className="accordion__header__left-content">
          <div className="clear-text" onClick={clearHandler}>
            <Trash />
          </div>

          <div className="accordion__header__arrow">
            <ArrowGrayIcon />
          </div>
        </div>
      </>
    );
  };

  const containerElement = useRef();

  const openAccordionHandler = () => {
    setIsOpen(!isOpen);
  };

  const contentContainerStyles = isOpen
    ? { height: "unset", display: 'initial' }
    : { height: "0px", display: 'none' };

  return (
    <div className={classNames("accordion", { accordion__open: isOpen })}>
      <div className="accordion__header" onClick={openAccordionHandler}>
        {headerComponent ? headerComponent : renderAccordionHeader(headerProps)}
      </div>
      <div
        className="accordion__content"
        ref={containerElement}
        style={contentContainerStyles}
      >
        {children}
      </div>
    </div>
  );
};

export default Accordion;
